import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './index.css';
import Game from './Game';
import makeGame from './non-react/casualcombocountry';

const hudElement = document.getElementById('root');

let dialogState = { splashScreen: true };
let gameState = {};

const setDialogState = state => dialogState = state;
const setGameState = state => gameState = state;

const render = () => {
  const newDialogState = { ...dialogState };
  const newGameState = { ...gameState };
  ReactDOM.render(
    <React.StrictMode>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={
            <Game
             dialogState={newDialogState}
             gameState={newGameState}
             openLogBook={() => game.openLogBook()}
             onSelectAdvancement={(id, uv) => game.selectAdvancement(id, uv)}
             onRemoveAdvancements={(cost, uv) => game.removeAdvancements(cost, uv)}
             onCloseNewAdvancements={() => game.closeNewAdvancements()}
             onCloseHint={() => game.closeHint()}
             onCloseNewUniqueResource={() => game.closeNewUniqueResource()}
             onCloseLogBook={() => game.closeLogBook()}
             onCloseSplashScreen={() => { setDialogState({}); render(); }}
             buyHint={() => game.buyHint()}
             />
          } />
        </Routes>
      </BrowserRouter>
    </React.StrictMode>,
    hudElement
  );
}

const game = makeGame(document.getElementsByTagName('canvas')[0], 20, 12, 100, render, setDialogState, setGameState);

const scheduleTick = () => {
  setTimeout(() => {
    game.tick();
    scheduleTick();
  }, Math.round(100-gameState.usedAdvancements/gameState.allAdvancements*75));
};

scheduleTick();